import type { ThemeConfig } from 'antd';

/**
 * Tokens del Design System Soluciones Andinas (02_lineamientos_visuales.md), acotados por ahora
 * a Solicitudes Juridicas (AB#10842): el resto de la app sigue con el theme global (#0886CF)
 * hasta que se migre cada seccion aparte. Se comparte entre la lista y el detalle para no
 * duplicar los valores.
 */
export const dsTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1798D5',
    colorSuccess: '#22C55E',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#3B82F6',
    colorText: '#232323',
    colorTextSecondary: '#656666',
    colorTextTertiary: '#8C8C8C',
    fontFamily: 'var(--sa-font-body)',
    borderRadius: 8,
  },
};
